import React from "react";
import emailjs from '@emailjs/browser';
import './Contact.css'
import { useRef } from "react";
import { useState } from "react";
import { themeContext } from "../../Context";
import { useContext } from "react";
const Contact = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

        const form = useRef();
        const [done, setDone] = useState (false)

        const sendEmail = (e) => {
          e.preventDefault();
      
          emailjs.sendForm('service_k3fbg96', 'template_638ga7n', form.current, 'Z08dGk9acoBaDE3-D')
            .then((result) => {
                console.log(result.text);
                setDone(true);
            }, (error) => {
                console.log(error.text);
            });
        };


    return(
        <div className="Contact-from">

            <div className="w-left">
                <div className="awesome">
                    <span style={{color: darkMode? 'white': ''}}>Get in touch</span>
                    <span>Contact me</span>
                </div>
                <div className="blur s-blur2" style={{background:"#ABF1FF94"}}></div>
                
            </div>

<div className="c-right">
    <form ref={form} onSubmit={sendEmail}>
        <input type="text" name="user_name" className="user" placeholder="Name"/>
        <input type="Email" name="user_email" className="user" placeholder="Email"/>
      <textarea name="message" className="user" placeholder="Message"/>
        <input type="submit" value="Send" className="button"/>
        <span>{done && "Thanks for contactin me"}</span>
        <div className="blur c-blur1" style={{background: "var(--purple)"}}> </div> 
    </form>
</div>


        </div>
    )
}

export default Contact